import React from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { GetFoodCompensationStatus } from "../../actions/teacherQueries";
import { formatDate } from "../../Utilities/dateUtils";
import { FormattedMessage } from "react-intl";

export default function FoodCompensationInformationForStudentModal({
  close,
  isOpen,
  student,
  periodId,
}) {
  const foodCompensationData = GetFoodCompensationStatus(student.id, periodId);

  if (foodCompensationData.isPending) {
    return null;
  }

  return (
    <Modal size="md" isOpen={isOpen} toggle={close}>
      <ModalHeader toggle={close}>
        <FormattedMessage id="FoodCompensation" />
      </ModalHeader>
      <ModalBody>
        {foodCompensationData.data?.length > 0 ? (
          <div>
            <p>
              {student.name}{" "}
              <FormattedMessage id="HasRequestedNonFoodCompensationForFollowingDatesInThePeriod" />
              :
            </p>
            {foodCompensationData.data.map((item) => {
              return <div>{formatDate(item.day, "do MMMM yyyy")}</div>;
            })}
          </div>
        ) : (
          <span>
            {student.name}{" "}
            <FormattedMessage id="HasNotRequestedNonFoodCompensationForThePeriod" />
          </span>
        )}
      </ModalBody>
      <ModalFooter style={{ display: "block" }}>
        <Button
          onClick={() => close()}
          className={"float-end"}
          outline
          color="primary"
        >
          <FormattedMessage id="Ok" />
        </Button>
      </ModalFooter>
    </Modal>
  );
}
